<template>
	<app-page>
		<app-heading title="MarketMath Airbnb Data" />
		<app-row>
			<app-cell>
				<app-data-table
					:items="markets"
					:headers="headers"
					:total="count"
					@update="fetchMarkets"
				>
					<template v-slot:actions="{ item }">
						<app-button
							v-if="$ravello.can('marketmath.get')"
							color="secondary"
							table
							@click="onManage(item._id)"
						>
							Manage
						</app-button>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
import countriesMap from '@/mixins/countriesMap'

export default {
	mixins: [countriesMap],
	data() {
		return {
			markets: [],
			count: -1,
			headers: [{
				text: 'State/Province',
				value: 'name',
				sortable: true,
			}, {
				text: 'Slug',
				value: 'slug',
				sortable: true,
			}, {
				text: 'Timezone',
				value: 'timezone',
				sortable: false,
			}, {
				text: 'Country',
				value: 'country',
				sortable: false,
				cb: item => this.getCountry(item.country),
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		onManage(id) {
			this.$store.dispatch('app/setNav', false)
			this.$router.push({ name: 'market-airbnb-crawlers', params: { market: id } })
		},
		async fetchMarkets(pagination) {
			const request = this.$ravello.graphql('markets')
				.fromPagination(pagination)
				.fields(['_id', 'name', 'slug', 'timezone', 'country'])

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.markets = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
	},
}
</script>
